<template>
  <el-select
    v-model="selectedAllergies"
    :placeholder="$t('settings.dropDownPlaceholder')"
    multiple
    @change="updateAllergies()"
  >
    <el-option
      v-for="allergy in allergies"
      :key="allergy.name"
      :label="allergy.name"
      :value="allergy.id"
    >
    </el-option>
  </el-select>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'AllergySelector',
  data() {
    return {
      selectedAllergies: [],
    };
  },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.selectedAllergies = this.selected;
    this.updateAllergies();
  },
  computed: {
    ...mapState('allergies', { allergies: (state) => state.allergies }),
  },
  methods: {
    updateAllergies() {
      this.$emit('change', this.selectedAllergies);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';

.el-select-dropdown {
  &__item {
    font-family: 'Avenir';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AllergySelector.vue